module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae-3.daa157e9414798923fbf84824bbc04d3.webp";